var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:quote-left",
    clipPath: "url(#clip0_126_3102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-9.15527e-05 21.2149C-9.15527e-05 14.7033 5.27401 9.4292 11.7856 9.4292H12.5713C14.3097 9.4292 15.7142 10.8337 15.7142 12.5721C15.7142 14.3104 14.3097 15.7149 12.5713 15.7149H11.7856C8.7508 15.7149 6.28562 18.1801 6.28562 21.2149V22.0006H12.5713C16.0383 22.0006 18.8571 24.8194 18.8571 28.2863V34.5721C18.8571 38.039 16.0383 40.8578 12.5713 40.8578H6.28562C2.81866 40.8578 -9.15527e-05 38.039 -9.15527e-05 34.5721V21.2149ZM25.1428 21.2149C25.1428 14.7033 30.4169 9.4292 36.9285 9.4292H37.7142C39.4526 9.4292 40.8571 10.8337 40.8571 12.5721C40.8571 14.3104 39.4526 15.7149 37.7142 15.7149H36.9285C33.8937 15.7149 31.4285 18.1801 31.4285 21.2149V22.0006H37.7142C41.1812 22.0006 43.9999 24.8194 43.9999 28.2863V34.5721C43.9999 38.039 41.1812 40.8578 37.7142 40.8578H31.4285C27.9615 40.8578 25.1428 38.039 25.1428 34.5721V21.2149Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_3102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 50.2857,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review_.c2a08635ebf8880f7d34c2dfef9ddc28.svg";
export { ForwardRef as ReactComponent };